"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getSubAccount = exports.getBlock = exports.broadcastTransaction = exports.getFeesEstimation = exports.getGasEstimation = exports.getTransactionCount = exports.getTokenBalance = exports.getCoinBalance = exports.getTransaction = exports.getBalanceAndBlock = exports.withApi = exports.DEFAULT_RETRIES_RPC_METHODS = void 0;
/** ⚠️ keep this order of import. @see https://docs.ethers.io/v5/cookbook/react-native/#cookbook-reactnative ⚠️ */
var ethers_1 = require("ethers");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var adapters_1 = require("../adapters");
var errors_1 = require("../errors");
var erc20_abi_json_1 = __importDefault(require("../abis/erc20.abi.json"));
var logs_1 = require("@ledgerhq/logs");
exports.DEFAULT_RETRIES_RPC_METHODS = 2;
/**
 * Connects to RPC Node
 */
function withApi(currency, execute, retries) {
    var _a, _b;
    if (retries === void 0) { retries = exports.DEFAULT_RETRIES_RPC_METHODS; }
    return __awaiter(this, void 0, void 0, function () {
        var provider, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((_a = currency === null || currency === void 0 ? void 0 : currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.rpc)) {
                        throw new Error("Currency doesn't have an RPC node provided");
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    provider = new ethers_1.ethers.providers.JsonRpcProvider((_b = currency === null || currency === void 0 ? void 0 : currency.ethereumLikeInfo) === null || _b === void 0 ? void 0 : _b.rpc);
                    return [4 /*yield*/, execute(provider)];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    e_1 = _c.sent();
                    if (retries) {
                        // decrement with prefix here or it won't work
                        return [2 /*return*/, withApi(currency, execute, --retries)];
                    }
                    throw e_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.withApi = withApi;
/**
 * Get account balance and last chain block
 */
var getBalanceAndBlock = function (currency, addr) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
                var _a, balance, blockHeight;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                (0, exports.getCoinBalance)(currency, addr),
                                api.getBlockNumber(),
                            ])];
                        case 1:
                            _a = __read.apply(void 0, [_b.sent(), 2]), balance = _a[0], blockHeight = _a[1];
                            return [2 /*return*/, {
                                    blockHeight: blockHeight,
                                    balance: new bignumber_js_1["default"](balance.toString())
                                }];
                    }
                });
            }); })];
    });
}); };
exports.getBalanceAndBlock = getBalanceAndBlock;
/**
 * Get a transaction by hash
 */
var getTransaction = function (currency, hash) {
    return withApi(currency, function (api) {
        return api.getTransaction(hash);
    });
};
exports.getTransaction = getTransaction;
/**
 * Get the balance of an address
 */
var getCoinBalance = function (currency, address) {
    return withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
        var balance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.getBalance(address)];
                case 1:
                    balance = _a.sent();
                    return [2 /*return*/, new bignumber_js_1["default"](balance.toString())];
            }
        });
    }); });
};
exports.getCoinBalance = getCoinBalance;
/**
 * Get the balance of an address
 */
var getTokenBalance = function (currency, address, contractAddress) {
    return withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
        var erc20, balance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    erc20 = new ethers_1.ethers.Contract(contractAddress, erc20_abi_json_1["default"], api);
                    return [4 /*yield*/, erc20.balanceOf(address)];
                case 1:
                    balance = _a.sent();
                    return [2 /*return*/, new bignumber_js_1["default"](balance.toString())];
            }
        });
    }); });
};
exports.getTokenBalance = getTokenBalance;
/**
 * Get account nonce
 */
var getTransactionCount = function (currency, addr) {
    return withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.getTransactionCount(addr)];
        });
    }); });
};
exports.getTransactionCount = getTransactionCount;
/**
 * Get an estimated gas limit for a transaction
 */
var getGasEstimation = function (account, transaction) {
    return withApi(account.currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, to, value, data, gasEtimation, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, adapters_1.transactionToEthersTransaction)(transaction), to = _a.to, value = _a.value, data = _a.data;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.estimateGas({
                            from: account.freshAddress,
                            to: to,
                            value: value,
                            data: data
                        })];
                case 2:
                    gasEtimation = _b.sent();
                    return [2 /*return*/, new bignumber_js_1["default"](gasEtimation.toString())];
                case 3:
                    e_2 = _b.sent();
                    (0, logs_1.log)("error", "EVM Family: Gas Estimation Error", e_2);
                    throw new errors_1.GasEstimationError();
                case 4: return [2 /*return*/];
            }
        });
    }); });
};
exports.getGasEstimation = getGasEstimation;
/**
 * Get an estimation of fees on the network
 */
var getFeesEstimation = function (currency) {
    return withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
        var block, supports1559, feeData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.getBlock("latest")];
                case 1:
                    block = _a.sent();
                    supports1559 = Boolean(block.baseFeePerGas);
                    return [4 /*yield*/, (function () { return __awaiter(void 0, void 0, void 0, function () {
                            var feeHistory, maxPriorityFeePerGas, nextBaseFee, gasPrice;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!supports1559) return [3 /*break*/, 2];
                                        return [4 /*yield*/, api.send("eth_feeHistory", [
                                                "0x5",
                                                "latest",
                                                [50], // 50% percentile sample
                                            ])];
                                    case 1:
                                        feeHistory = _a.sent();
                                        maxPriorityFeePerGas = feeHistory.reward
                                            .reduce(function (acc, _a) {
                                            var _b = __read(_a, 1), curr = _b[0];
                                            return acc.plus(new bignumber_js_1["default"](curr));
                                        }, new bignumber_js_1["default"](0))
                                            .dividedToIntegerBy(feeHistory.reward.length);
                                        nextBaseFee = new bignumber_js_1["default"](feeHistory.baseFeePerGas[feeHistory.baseFeePerGas.length - 1]);
                                        return [2 /*return*/, {
                                                maxPriorityFeePerGas: maxPriorityFeePerGas,
                                                maxFeePerGas: nextBaseFee.multipliedBy(2).plus(maxPriorityFeePerGas)
                                            }];
                                    case 2: return [4 /*yield*/, api.getGasPrice()];
                                    case 3:
                                        gasPrice = _a.sent();
                                        return [2 /*return*/, {
                                                gasPrice: gasPrice
                                            }];
                                }
                            });
                        }); })()];
                case 2:
                    feeData = _a.sent();
                    return [2 /*return*/, {
                            maxFeePerGas: feeData.maxFeePerGas
                                ? new bignumber_js_1["default"](feeData.maxFeePerGas.toString())
                                : null,
                            maxPriorityFeePerGas: feeData.maxPriorityFeePerGas
                                ? new bignumber_js_1["default"](feeData.maxPriorityFeePerGas.toString())
                                : null,
                            gasPrice: feeData.gasPrice
                                ? new bignumber_js_1["default"](feeData.gasPrice.toString())
                                : null
                        }];
            }
        });
    }); });
};
exports.getFeesEstimation = getFeesEstimation;
/**
 * Broadcast a serialized transaction
 */
var broadcastTransaction = function (currency, signedTxHex) {
    return withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.sendTransaction(signedTxHex)];
        });
    }); });
};
exports.broadcastTransaction = broadcastTransaction;
/**
 * Get the informations about a block by block height
 */
var getBlock = function (currency, blockHeight) {
    return withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, api.getBlock(blockHeight)];
        });
    }); });
};
exports.getBlock = getBlock;
/**
 * Get account balances and nonce
 */
var getSubAccount = function (currency, addr) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, withApi(currency, function (api) { return __awaiter(void 0, void 0, void 0, function () {
                var _a, balance, nonce, blockHeight;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                (0, exports.getCoinBalance)(currency, addr),
                                (0, exports.getTransactionCount)(currency, addr),
                                api.getBlockNumber(),
                            ])];
                        case 1:
                            _a = __read.apply(void 0, [_b.sent(), 3]), balance = _a[0], nonce = _a[1], blockHeight = _a[2];
                            return [2 /*return*/, {
                                    blockHeight: blockHeight,
                                    balance: new bignumber_js_1["default"](balance.toString()),
                                    nonce: nonce
                                }];
                    }
                });
            }); })];
    });
}); };
exports.getSubAccount = getSubAccount;
exports["default"] = {
    DEFAULT_RETRIES_RPC_METHODS: exports.DEFAULT_RETRIES_RPC_METHODS,
    withApi: withApi,
    getBalanceAndBlock: exports.getBalanceAndBlock,
    getTransaction: exports.getTransaction,
    getCoinBalance: exports.getCoinBalance,
    getTransactionCount: exports.getTransactionCount,
    getGasEstimation: exports.getGasEstimation,
    getFeesEstimation: exports.getFeesEstimation,
    broadcastTransaction: exports.broadcastTransaction,
    getBlock: exports.getBlock
};
//# sourceMappingURL=rpc.common.js.map